import React from 'react';
import BaseView from '../../components/CRUDView';
import {PaymentsEndpoints, TractorOwnerEndpoints} from "../../common/ProxyEndpoints";
import AppVariables from '../../common/AppVariables';
import {TimeRangeInfo, TimeRangeSelectionDialog} from '../Request/RequestCommon';
import NumberLabel from "../../components/NumberLabel/NumberLabel";
import Utils from "../../common/Utils";
import _ from "lodash";
import {RequestStatusFilter} from "../Request/RequestStatusConfiguration";
import CurrencyLabel from "../../components/CurrencyLabel/CurrencyLabel";
import {PaymentInfoView} from "./PaymentInfoView";
import {
    CustomPayoutsFilters,
    parsePayoutFilters,
    PaymentStatusBadge,
    PAYOUTS_FILTERS
} from "../Extras/Finance/TractorOwnerPayouts/PayoutsCommon";
import {RequestPaymentStatus} from "../../common/Constants";
import EventListener from "../../common/EventListener";
import EventActions from "../../common/Events/Actions";
import {formatServiceQuantity} from "../../common/QuantityHelper";

const SearchProps = [
    'local_reference',
    'external_reference',
    'amount',
    'receiver_account_name',
    'receiver_account_no'
];

const PaymentStatus = [
    { text: <span><i className="fa fa-check" style={{ color: "#00c157" }}/> Successful</span>, value: RequestPaymentStatus.Success },
    { text: <span><i className="fa fa-close" style={{ color: "#ff1300" }}/> Cancelled</span>, value: RequestPaymentStatus.Cancelled }
];

/**
 * Shows payments received by tractor owner
 */
class Revenue extends BaseView {

    constructor(props){
        super(props,"tractor_owner_revenue");
        this.onPaymentUpdate = this.onPaymentUpdate.bind(this);
        this.handleEvent = this.handleEvent.bind(this);
    }

    getOwnerId(){
        return this.getProxy().getUserInfo().owner.id;
    }

    onPaymentUpdate(){
        return this.refresh();
    }

    onExecuteRequest(url,params,{ filters }){

        let order = params.sort || (params.sort = []);
        const qs = params.query || (params.query = {});
        const {
            timeFrame,
            timeRangeStart,
            timeRangeEnd,
            status
        } = filters;

        if(!_.isNil(status)){

            const frame = RequestStatusFilter.find(x => x.value === status);
            if(frame && _.isFunction(frame.onApply)){
                frame.onApply(params);
            }

        }

        if(timeFrame){

            qs.filter_time_range = timeFrame;

            if(timeRangeStart) {
                qs.range_from = timeRangeStart.toJSON();
            }

            if(timeRangeEnd)
                qs.range_to = timeRangeEnd.toJSON();
        }

    }

    /**
     * Sets the time range to display
     */
    setTimeRangeDisplay(opts){

        const _update = {
            timeFrame: opts.range,
            timeRangeStart: opts.start ? opts.start.toJSON() : null,
            timeRangeEnd: opts.end ? opts.end.toJSON() : null
        };

        //
        this.setQueryFiltersRaw(filters => ({ ...filters, ..._update }));
    }

    getCustomFilterState(filters) {
        return parsePayoutFilters(filters);
    }

    componentWillMount(){

        const me = this;

        //  set view options
        this.setViewOptions({

            //  The message to show when there are no items in the view
            noRowsMessage: 'No payments received yet!',

            //  The class icon for the card header
            pageIcon: 'fa fa-money',

            //  The title for the content frame
            pageTitle: 'Payments',

            //  The total number of items per page
            maxItemsPerPage: AppVariables.MaxItemsPerPage,

            //  Defines the features of the view
            features: [ 'toolbox' , 'search' ],

            multiSelection: {

                //  enable multi-selection
                enable : false,
            },

            hooks:{

                //  Called before every query to get items
                preQueryHook: null

            },

            //  defines (CRUD) actions enabled on the items
            actions:{

                //  create action options
                create:{
                    enabled: false,
                },

                //  delete action options
                delete:{
                    enabled : false,
                },

                //  delete action options
                edit:{
                    enabled : false
                }

            },

            model: {

                include: [
                    'tractor_request',
                    "wallet"
                ]

            },

            queryActions: {
                //  The endpoint for query actions
                endpoint: PaymentsEndpoints.getUrl()
            },

            filters: Utils.excludeFilters(PAYOUTS_FILTERS,[
                'owner_id',
                'tractorOwnerName',
                'farmerId',
                'farmerName'
            ]),

            renderCustomFilters: (props) => <CustomPayoutsFilters fetchTractors={async params => (await me.execReq(TractorOwnerEndpoints.getTractors(this.getOwnerId()).url,params)).getPayload()}
                                                                  fetchOperators={async params => (await me.execReq(TractorOwnerEndpoints.getOperators(this.getOwnerId()).url,params)).getPayload()}
                                                                  {...props}/>,

            search: {

                //
                placeholder: 'Search payments...',

                //  the mode for searching
                //  immediate: responsive
                //  explicit: wait till user hits the search button
                mode: 'explicit',

                //  The minimum characters to begin search with
                minSearchChars: 2,

                properties: SearchProps
            },

            //  Defines actions for toolbox
            toolBox: [
                {  text : 'Refresh'  , icon : 'fa fa-refresh'  , invoke: () => me.refresh() , position: 'right' },
                {  text : 'Status'  , icon : 'fa fa-signal' , invoke: (index) => { me.updateQuery('status', PaymentStatus[index].value,true) }, position: 'right' , group : 'filter' , items: PaymentStatus.map(x => x.text) },
                {
                    text: '', icon: 'fa fa-calendar',   items: Object.keys(TimeRangeInfo).map(x => TimeRangeInfo[x].label), position: 'left' , style: { marginRight: 10 } , invoke: index => {

                        let timeFrame = Object.keys(TimeRangeInfo)[index];
                        if (timeFrame === "custom") {

                            const filters = this.getQueryFilters();

                            //  show dialog for selecting time range
                            this._timeRangeSelectionDlg.show({
                                start: filters.timeRangeStart,
                                end: filters.timeRangeEnd
                            });

                            //  prevent selection of item
                            return false;

                        } else {

                            this.setTimeRangeDisplay({
                                range: timeFrame
                            });

                        }

                    }
                },
                {  text : ''  , icon : 'fa fa-gears' , invoke: (index) => {

                        switch (index){
                            case 0:
                                return  me.toggleCustomFilterVisibility();
                        }

                    }, position: 'right' , group : 'more' ,
                    items: () => ([
                        <span><i className={me.isCustomFilterViewVisible() ? "fa fa-chevron-up" : "fa fa-chevron-down"}/> {me.isCustomFilterViewVisible() ? "Hide" : "Show"} Advanced Filters</span>
                    ]),
                    sticky: false,
                }
            ],

            //  Inputs used in editing and creating items
            inputs: [],

            // Describes the columns present in the table
            columns : [
                {key: 'local_reference' , label: () => me.sortCol('Reference','local_reference')  },
                {key: 'amount', label: () => me.sortCol('Amount','amount'), cell: item => <CurrencyLabel currency={item.currency} value={item.amount}/>, mobile: true },
                {key: "wallet", label: "Wallet", cell: item => item.receiver_account_no},
                {key: "tractor_request" , label: "Request" , cell: item => <span>{formatServiceQuantity(item.tractor_request,{ acre: 'acres' , hectare: 'hectares' , service: item.tractor_request.service })} / {`${item.tractor_request.service.name}`}</span>},
                {key: 'status' , label: "Status", cell: item => <PaymentStatusBadge payment={item}/>},
                {key: 'date_created' , label: () => me.sortCol("Date Issued",'date_created') , format: 'date' , mobile: true  },
            ],

            //  Describes details to show when clicked
            detailsDisplay: {

                //  enable or disable
                enabled: true,

                //  called to render the title of the dialog if defined
                renderTitle: (item) => {
                    return `Payment Info (${item.local_reference})`
                },

                //  Indicates whether the dialog is larger
                large: true,

                //  called to render the display window content if defined
                customRender: (item) => (<PaymentInfoView payment={item}/>),

                //  The properties to render in the details dialog
                properties: [],

                //  Called to render to footer for the details dialog
                renderFooter: null,

                //  Invoked before showing
                onShow: () => { }
            },

            //  Processors
            processors :{

            }
        });

    }

    handleEvent(event,data){

        switch (event) {
            case EventActions.PaymentsUpdate:
                this.onPaymentUpdate();
                break;
        }
    }

    renderExtra() {

        return <React.Fragment>
            <EventListener events={[EventActions.PaymentsUpdate]}  onEvent={this.handleEvent} />
        </React.Fragment>;

    }

    renderDialogs(dialog) {

        const timeRangeInfo = this.state.timeRangeInfo || {};

        return <React.Fragment>

            {super.renderDialogs(dialog)}

            <TimeRangeSelectionDialog ref={r => this._timeRangeSelectionDlg = r}
                                      from={timeRangeInfo.start}
                                      to={timeRangeInfo.end}
                                      onApply={({ start , end }) => {

                                          this.setTimeRangeDisplay({
                                              range: "custom",
                                              start,
                                              end
                                          });

                                      }}/>
        </React.Fragment>

    }


}

export  default Revenue;



// WEBPACK FOOTER //
// ./src/views/Revenue/Revenue.js